document.addEventListener("click", function (event) {
  if (event.target.parentElement.matches("#back-to-list")) {
    event.preventDefault()
    const filtersUrl = localStorage.getItem("history_filters_url")
    if (filtersUrl) {
      window.location.href = filtersUrl
    }
  }
})
